import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { fetchingState } from '@constants';
import * as actions from '../actions/property';

const initialState = fromJS({
  propertyChanges: {
    data: {},
    state: null,
  },
  propertiesBySearch: {},
  searchFormData: {},
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
});

const PropertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_PROPERTY_CHANGES_START: {
      return state
        .setIn(['propertyChanges', 'state'], fetchingState.FETCHING)
        .setIn(
          ['propertyChanges', 'data'],
          fromJS(_.get(action, 'data.results', {}) || {}),
        );
    }
    case actions.GET_PROPERTY_CHANGES_SUCCESS: {
      return state
        .setIn(['propertyChanges', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyChanges', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.SET_PROPERTY_CHANGE_MAIN_IMAGE_SUCCESS: {
      const changes = state.getIn(['propertyChanges', 'data']).toJS();
      const newChanges = _.get(action, 'data.results[0]', {});
      for (
        let i = 0;
        i < newChanges.changedData.capturedFieldImages.length;
        i++
      ) {
        newChanges.changedData.capturedFieldImages[i].signedURL =
          changes.changedData.capturedFieldImages[i].signedURL;
      }
      return state
        .setIn(['propertyChanges', 'state'], fetchingState.LOADED)
        .setIn(['propertyChanges', 'data'], fromJS(newChanges));
    }
    case actions.GET_PROPERTY_CHANGES_ERROR: {
      return state.setIn(['property', 'state'], fetchingState.ERROR);
    }

    case actions.SEARCH_PROPERTY_START:
      return state
        .setIn(['propertiesBySearch', 'state'], fetchingState.FETCHING)
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);

    case actions.SEARCH_PROPERTY_SUCCESS:
      return state
        .setIn(['propertiesBySearch', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertiesBySearch', 'total'],
          fromJS(_.get(action, 'data.totalProperties.propertyCount', 0)),
        )
        .setIn(
          ['propertiesBySearch', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['pagination', 'count'],
          fromJS(_.get(action, 'data.totalProperties.propertyCount', 0)),
        );

    case actions.SEARCH_PROPERTY_ERROR:
      return state.setIn(['propertiesBySearch', 'state'], fetchingState.ERROR);
    case actions.SET_SEARCH_FORM_DATA: {
      return state.setIn(['searchFormData'], fromJS(action.payload));
    }
    case actions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    default: {
      return state;
    }
  }
};

export default PropertyReducer;
